<template lang="pug">
  b-container(fluid)
    b-row
      b-col.mb-3.p-0
        GeneralMenu
    b-row.thirdPart.pb-5
      b-col(cols="3")
      b-col(cols="6")
        h2.text-center Case-studies
        div.line
        p.text-center The table below lists all published studies which comprise the nature-based wastewater evidence database. Table entries can be filtered using the ‘Filter’ button above. Table entries can be exported using the ‘Export’ button (if a filter has been applied, only displayed entries will be exported).
      b-col(cols="3")
    b-row.p-5
      b-col
        b-button.buttonStyle(squared variant="outline-primary" @click="exportData(null,filteredData,'exported')").float-right Export
    b-row.pb-2
      b-col
    b-row.m-5.border-bottom.pb-2.mb-3
      b-col.p-0
        a(type="button" v-b-toggle.filters style="") FILTERS
        b-icon(v-b-toggle.filters icon="chevron-up" size="sm").float-right
    b-row.m-5
      b-col
        b-collapse(id="filters")
          b-form-group(label-cols="4" label="Type" label-align="left")
            b-form-select(v-model="technology.case_tech_type" :options="type_options")
          b-form-group(label-cols="4" label="Sub-type" label-align="left")
            b-form-select(v-model="technology.case_tech_subtype" :options="subType_options" )
          b-row
            b-col(cols="6")
              InputRange(label="BOD In", id_custom="case_spec_bod_in", type="number" , description="", :value="specifications.low.bod" sufix="mg/L",  @input="(val) => {specifications.low.bod = val}")
              InputRange(label="COD In", id_custom="case_spec_cod_in", type="number" , description="", :value="specifications.low.cod" sufix="mg/L",  @input="(val) => {specifications.low.cod = val}")
              InputRange(label="TN In", id_custom="case_spec_tn_in", type="number" , description="", :value="specifications.low.tn" sufix="mgN/L",  @input="(val) => {specifications.low.tn = val}")
              InputRange(label="NO3 In", id_custom="case_spec_no3_in", type="number" , description="", :value="specifications.low.no3" sufix="mgN/L",  @input="(val) => {specifications.low.no3 = val}")
              InputRange(label="NH4 In", id_custom="case_spec_nh4_in", type="number" , description="", :value="specifications.low.nh4" sufix="mgN/L",  @input="(val) => {specifications.low.nh4 = val}")
              InputRange(label="TP In", id_custom="case_spec_tp_in", type="number" , description="", :value="specifications.low.tp" sufix="mgP/L",  @input="(val) => {specifications.low.tp = val}")
              InputRange(label="PO43 In", id_custom="case_spec_po43_in", type="number" , description="", :value="specifications.low.po43" sufix="mgP/L",  @input="(val) => {specifications.low.po43 = val}")
              InputRange(label="ECOLI In", id_custom="case_spec_ecoli_in", type="number" , description="", :value="specifications.low.ecoli" sufix="CFUL/L",  @input="(val) => {specifications.low.ecoli = val}")
              InputRange(label="HEGGS In", id_custom="case_spec_heggs_in", type="number" , description="", :value="specifications.low.heggs" sufix="eggs/L",  @input="(val) => {specifications.low.heggs = val}")
            b-col(cols="6")
              InputRange(label="BOD OUT", id_custom="case_spec_bod_out", type="number" , description="", :value="specifications.high.bod" sufix="mg/L",  @input="(val) => {specifications.high.bod = val}")
              InputRange(label="COD OUT", id_custom="case_spec_cod_out", type="number" , description="", :value="specifications.high.cod" sufix="mg/L",  @input="(val) => {specifications.high.cod = val}")
              InputRange(label="TN OUT", id_custom="case_spec_tn_out", type="number" , description="", :value="specifications.high.tn" sufix="mgN/L",  @input="(val) => {specifications.high.tn = val}")
              InputRange(label="NO3 OUT", id_custom="case_spec_no3_out", type="number" , description="", :value="specifications.high.no3" sufix="mgN/L",  @input="(val) => {specifications.high.no3 = val}")
              InputRange(label="NH4 OUT", id_custom="case_spec_nh4_out", type="number" , description="", :value="specifications.high.nh4" sufix="mgN/L",  @input="(val) => {specifications.high.nh4 = val}")
              InputRange(label="TP OUT", id_custom="case_spec_tp_out", type="number" , description="", :value="specifications.high.tp" sufix="mgP/L",  @input="(val) => {specifications.high.tp = val}")
              InputRange(label="PO43 OUT", id_custom="case_spec_po43_out", type="number" , description="", :value="specifications.high.po43" sufix="mgP/L",  @input="(val) => {specifications.high.po43 = val}")
              InputRange(label="ECOLI OUT", id_custom="case_spec_ecoli_out", type="number" , description="", :value="specifications.high.ecoli" sufix="CFUL/L",  @input="(val) => {specifications.high.ecoli = val}")
              InputRange(label="HEGGS OUT", id_custom="case_spec_heggs_out", type="number" , description="", :value="specifications.high.heggs" sufix="eggs/L",  @input="(val) => {specifications.high.heggs = val}")
    b-row
      b-col
        b-table(:items="filteredData" :fields="fields" hover sticky-header="80vh")
          //template #table-colgroup="scope">
            col(v-for="field in scope.fields" :key="field.key" :style="{ width: field.key === 'foo' ? '120px' : '180px' }")
          //template(v-slot:head(no3)="data")
          //  span(v-html="data.field.label")
          //template(v-slot:head(nh4)="data")
          //  span(v-html="data.field.label")
          //template(v-slot:head(surface)="data")
          //  span(v-html="data.field.label")
          //template(v-slot:head(inflow)="data")
          //  span(v-html="data.field.label")
          //template(v-slot:head(po43)="data")
          //  span(v-html="data.field.label")
          template(v-slot:cell(sub_type)="myData")
            span(v-if="myData.value != 'undefined'") {{ myData.value }}
          //template(v-slot:cell(bod)="myData")
          //  span(v-if="myData.item.bod_in != null") {{ myData.item.bod_in }}/{{ myData.item.bod_out }}
          //template(v-slot:cell(cod)="myData")
          //  span(v-if="myData.item.cod_in != null") {{ myData.item.cod_in }}/{{ myData.item.cod_out }}
          //template(v-slot:cell(tn)="myData")
          //  span(v-if="myData.item.tn_in != null") {{ myData.item.tn_in }}/{{ myData.item.tn_out }}
          //template(v-slot:cell(no3)="myData")
          //  span(v-if="myData.item.no3_in != null") {{ myData.item.no3_in }}/{{ myData.item.no3_out }}
          //template(v-slot:cell(nh4)="myData")
          //  span(v-if="myData.item.nh4_in != null") {{ myData.item.nh4_in }}/{{ myData.item.nh4_out }}
          //template(v-slot:cell(tp)="myData")
          //  span(v-if="myData.item.tp_in != null") {{ myData.item.tp_in }}/{{ myData.item.tp_out }}
          //template(v-slot:cell(po43)="myData")
          //  span(v-if="myData.item.po43_in != null") {{ myData.item.po43_in }}/{{ myData.item.po43_out }}
          //template(v-slot:cell(heggs)="myData")
          //  span(v-if="myData.item.heggs_in != null") {{ myData.item.heggs_in }}/{{ myData.item.heggs_out }}
          //template(v-slot:cell(ecoli)="myData")
          //  span(v-if="myData.item.ecoli_in != null") {{ myData.item.ecoli_in }}/{{ myData.item.ecoli_out }}
          template(v-slot:cell(details)="myData")
            b-button(@click="myData.toggleDetails") {{ myData.detailsShowing ? 'Hide' : 'Show'}} Details
          template(v-slot:cell(design)="myData")
            b-row
              b-col()
                // { key: 'water_temp', label: 'Water Temp. (ºC)'},
                // { key: 'air_temp', label: 'Air Temp. (ºC)'},
                // { key: 'surface', label: 'Surface. (m<sup>2</sup>)'},
                // { key: 'hrt', label: 'HRT (h)'},
                // { key: 'inflow', label: 'Inflow (m<sup>3</sup>/d)'},
                // { key: 'population', label: 'Inhabitants'}
                TableRowSingle(label="Air Temp.:" :data_in="myData.item.water_temp" unit="ºC")
                TableRowSingle(label="Water Temp.:" :data_in="myData.item.air_temp" unit="ºC")
                TableRowSingle(label="Surface:" :data_in="myData.item.surface" unit="m<sup>2</sup>")
                TableRowSingle(label="HRT:" :data_in="myData.item.hrt" unit="h")
                TableRowSingle(label="Inflow:" :data_in="myData.item.inflow" unit="m<sup>3</sup>/d")
                TableRowSingle(label="Population:" :data_in="myData.item.population" unit="Inhabitants")
          template(v-slot:cell(technical)="myData")
            b-row
              b-col()
                TableRow(label="BOD:" :data_in="myData.item.bod_in" :data_out="myData.item.bod_out" unit="mgO<sub>2</sub>/L")
                TableRow(label="COD:" :data_in="myData.item.cod_in" :data_out="myData.item.cod_out" unit="mgO<sub>2</sub>/L")
                TableRow(label="TN:" :data_in="myData.item.tn_in" :data_out="myData.item.tn_out" unit="mgN/L")
                TableRow(label="NO<sub>3</sub><sup>-</sup>N:" :data_in="myData.item.no3_in" :data_out="myData.item.no3_out" unit="mgN/L")
                TableRow(label="NH<sub>4</sub><sup>+</sup>-N:" :data_in="myData.item.nh4_in" :data_out="myData.item.nh4_out" unit="mgN/L")
                TableRow(label="TP:" :data_in="myData.item.tp_in" :data_out="myData.item.tp_out" unit="mgP/L")
                TableRow(label="PO<sub>4</sub><sup>3-</sup>-P:" :data_in="myData.item.po43_in" :data_out="myData.item.po43_out" unit="mgP/L")
                TableRow(label="E.coli:" :data_in="myData.item.heggs_in" :data_out="myData.item.heggs_out" unit="CFU/L")
                TableRow(label="H.eggs:" :data_in="myData.item.ecoli_in" :data_out="myData.item.ecoli_in" unit="eggs/L")

          template(v-slot:cell(datajournal)="myData")
            span {{ myData.item.doc_data.title }}
          template(v-slot:row-details="row")
            b-row
              b-col(cols=3)
                div
                  span <b>DOI:</b> {{ row.item.doc_data.doi }}<br>
                  span <b>WOS:</b> {{ row.item.doc_data.wos }}<br>
                  span <b>Journal:</b> {{ row.item.doc_data.journal }}<br>
                  span <b>Year:</b> {{ row.item.doc_data.year }}<br>
                  span <b>Issue:</b> {{ row.item.doc_data.issue }}<br>
              b-col(cols=3)
                div
                  span <b>Author/s:</b> {{ row.item.doc_data.authors }}<br>
                  span <b>Pages:</b> {{ row.item.doc_data.startpage }}-{{ row.item.doc_data.endpage }}<br>
                  span <b>Volume:</b> {{ row.item.doc_data.volume }}<br>

</template>

<script>
import GeneralMenu from '@/components/GeneralMenu.vue'
import InputRange from '@/components/Inputs/InputRangeLowBig.vue'
import TableRow from '@/components/helpers/tableCaseStudieRow.vue'
import TableRowSingle from '@/components/helpers/tableCaseStudieRowSingle.vue'
const axios = require('axios');

export default {
  name: 'CaseFilter',
  components: {
    GeneralMenu,
    InputRange,
    TableRow,
    TableRowSingle
  },
  data(){
    return{
      showFilter: false,
      technology:{
        case_tech_type:"",
        case_tech_subtype:""
      },
      specifications: {
        low: {
          bod: {input: "", output: "", percentage: ""},
          cod: {input: "", output: "", percentage: ""},
          tn: {input: "", output: "", percentage: ""},
          no3: {input: "", output: "", percentage: ""},
          nh4: {input: "", output: "", percentage: ""},
          tp: {input: "", output: "", percentage: ""},
          po43: {input: "", output: "", percentage: ""},
          ecoli: {input: "", output: "", percentage: ""},
          heggs: {input: "", output: "", percentage: ""}
        },
        high: {
          bod: {input: "", output: "", percentage: ""},
          cod: {input: "", output: "", percentage: ""},
          tn: {input: "", output: "", percentage: ""},
          no3: {input: "", output: "", percentage: ""},
          nh4: {input: "", output: "", percentage: ""},
          tp: {input: "", output: "", percentage: ""},
          po43: {input: "", output: "", percentage: ""},
          ecoli: {input: "", output: "", percentage: ""},
          heggs: {input: "", output: "", percentage: ""}
        }
      },
      dataAll: [],
      fields: [
        //{ key: 'code_cs', label: 'Code'},
        { key: 'type', label: 'Type', tdClass: 'typeColClass'},
        { key: 'sub_type', label: 'Subtype', tdClass: 'typeColClass' },
        { key: 'dataJournal', label: 'Title', tdClass: 'titleColClass' },
        { key: 'details', label: 'Reference', tdClass: 'typeColClass' },
        { key: 'design', label: 'Design'},
        { key: 'technical', label: 'Water quality'}
        // { key: 'bod', label: 'BOD in/out (mg/L)'},
        // { key: 'tn', label: 'TN in/out (mgN/L)'},
        // { key: 'cod', label: 'COD in/out (mg/L)'},
        // { key: 'no3', label: 'NO<sub>3</sub><sup>-</sup>N in/out (mgN/L)'},
        // { key: 'nh4', label: 'NH<sub>4</sub><sup>+</sup>-N in/out (mgN/L)'},
        // { key: 'tp', label: 'TP in/out (mgP/L)'},
        // { key: 'po43', label: 'PO<sub>4</sub><sup>3-</sup>-P in/out (mgP/L)'},
        // { key: 'ecoli', label: 'E.coli in/out (CFUL/L)'},
        // { key: 'heggs', label: 'H.eggs in/out (CFUL/L)'},
        // { key: 'water_temp', label: 'Water Temp. (ºC)'},
        // { key: 'air_temp', label: 'Air Temp. (ºC)'},
        // { key: 'surface', label: 'Surface. (m<sup>2</sup>)'},
        // { key: 'hrt', label: 'HRT (h)'},
        // { key: 'inflow', label: 'Inflow (m<sup>3</sup>/d)'},
        // { key: 'population', label: 'Inhabitants'}
      ],
      type_options: [
        { value: "CW", text: 'Constructed wetlands' },
        { value: "GR", text: 'Green Roof' },
        { value: "GW", text: 'Green Wall' },
        { value: "HA", text: 'Hydroponics/Aquaponics' },
        { value: "MS", text: 'Multi Stage' },
        { value: "I-SRS", text: 'In-stream retention systems ' },
        { value: "NW", text: 'Natural Wetlands' },
        { value: "PL", text: 'Ponds/Lagoons' },
        { value: "SIS", text: 'Soil infiltration systems' },
        { value: "WS", text: 'Willow systems' }
      ]
    }
  },
  mounted() {
    this.getData();
  },
  methods:{
    toogleFilter(){
      this.showFilter = !this.showFilter;
    },
    filterInOut(object, id, table){
      if(object == null) return table;
      if(table == null) return table;
      if(table.length === 0) return table;
      if(id === "") return table;

      console.log("Table not null");

      table = table.filter(row => {
        if(object.low[id].input === null || object.low[id].input === '') return true;
        if(row[id+"_in"] === null || row[id+"_in"] === '') return false;
        console.log(object.low[id].input);
        return object.low[id].input <= row[id+"_in"]
      });

      table = table.filter(row => {
        if(object.low[id].output === null || object.low[id].output === '') return true;
        if(row[id+"_in"] === null || row[id+"_in"] === '') return false;
        return object.low[id].output >= row[id+"_in"]
      });

      table = table.filter(row => {
        if(object.high[id].input === null || object.high[id].input === '') return true;
        if(row[id+"_out"] === null || row[id+"_out"] === '') return false;
        console.log(object.high[id].input);
        return object.high[id].input <= row[id+"_out"]
      });

      table = table.filter(row => {
        if(object.high[id].output === null || object.high[id].output === '') return true;
        if(row[id+"_out"] === null || row[id+"_out"] === '') return false;
        return object.high[id].output >= row[id+"_out"]
      });

      return table;
    },
    cleanData(){
      this.dataAll = this.dataAll.filter(p=> {return p.surface > 0 && p.inflow > 0});
      for( let i = 0; i<this.dataAll.length;i++){
        this.dataAll[i].doc_data = JSON.parse(this.dataAll[i].doc_data);
      }
      //console.log(this.technologies_alpha[0]);
    },
    getData(){
      let _this = this;
      axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
      //axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;

      axios.get('https://snappAPI.icradev.cat/')
          .then(function (response) {
            // handle success
            _this.dataAll = JSON.parse(response.data.result);
            console.log("raw array:", _this.dataAll);
            _this.cleanData();
            console.log("raw array cleaned:", _this.dataAll);
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          });
    },
    exportData(headers, items, fileTitle) {
      let newItems = Object.assign([],items);
      if (headers) {
        newItems.unshift(headers);
      }
      var find = ';';
      var re = new RegExp(find, 'g');

      newItems.forEach(item => {
        item.doc_data = JSON.stringify(item.doc_data).replace(re,'|');
      });

      // Convert Object to JSON
      var jsonObject = JSON.stringify(newItems);

      var csv = this.convertToCSV(jsonObject);

      var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    convertToCSV(objArray) {
      var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      var str = '';

      for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
          if (line != '') {
            line += ';'
          }

          line += array[i][index];
        }

        str += line + '\r\n';
      }

      return str;
    }
  },
  computed:{
    filteredData(){
      let filteredData = this.dataAll;
      if(this.technology.case_tech_type !== ""){
        filteredData = filteredData.filter(line => {return line.type === this.technology.case_tech_type})
        if(this.technology.case_tech_subtype !== ""){
          filteredData = filteredData.filter(line => {return line.sub_type === this.technology.case_tech_subtype})
        }
      }

      filteredData = this.filterInOut(this.specifications,'bod',filteredData);
      filteredData = this.filterInOut(this.specifications,'cod',filteredData);
      filteredData = this.filterInOut(this.specifications,'tn',filteredData);
      filteredData = this.filterInOut(this.specifications,'no3',filteredData);
      filteredData = this.filterInOut(this.specifications,'nh4',filteredData);
      filteredData = this.filterInOut(this.specifications,'tp',filteredData);
      filteredData = this.filterInOut(this.specifications,'po43',filteredData);
      filteredData = this.filterInOut(this.specifications,'ecoli',filteredData);
      filteredData = this.filterInOut(this.specifications,'heggs',filteredData);

      return filteredData;
    },
    subType_options: function () {
      switch (this.technology.case_tech_type) {
        case "CW":
          return [
            { value: "", text: 'Please select an option' },
            { value: "CSO_CW", text: 'CSO' },
            { value: "French_CW", text: 'French configuration' },
            { value: "VSSF_CW", text: 'Vertical' },
            { value: "HSSF_CW", text: 'Horizontal' },
            { value: "FWS_CW", text: 'Free water surface' },
            { value: "IRM_CW", text: 'Intensified reactive media' },
            { value: "IA_CW", text: 'Intensified aeration' },
            { value: "R_CW", text: 'Recirculation' },
          ];
        case "GR":
          return [
            { value: "", text: 'Green Roof' },
          ];
        case "GW":
          return [
            { value: "", text: 'Green Wall' },
          ];
        case "HA":
          return [
            { value: "", text: 'Please select an option' },
            { value: "A_HA", text: 'Aquaponics' },
            { value: "H_HA", text: 'Hydroponics' },
          ];
        case "I-SRS":
          return [
            { value: "", text: 'In-stream retention systems ' },
          ];
        case "NW":
          return [
            { value: "", text: 'Natural Wetlands' },
          ];
        case "PL":
          return [
            { value: "", text: 'Please select an option' },
            { value: "IA_PL", text: 'Intensified aerated ' },
            { value: "AP_PL", text: 'Anaerobic' },
            { value: "FP_PL", text: 'Facultative' },
            { value: "MP_PL", text: 'Maturation' },
          ];
        case "SIS":
          return [
            { value: "", text: 'Please select an option' },
            { value: "SIS_R", text: 'Rapid' },
            { value: "SIS_S", text: 'Slow' },
          ];
        case "WS":
          return [
            { value: "", text: 'Willow systems' },
          ];
        case "MS":
          return [
            { value: "", text: 'Please select an option' },
            { value: "VSSF+HSSF_CW", text: 'Vertical CW followed by horizontal CW' },
            { value: "HSSF_CW+MP_PL", text: 'Horizontal CW followed by maturation pond'},
            { value: "AP+FP_PL", text: 'Anaerobic pond followed by facultative pond ' },
            { value: "AP+FP+MP_PL", text: 'Anaerobic pond followed by facultative pond followed by maturation pond ' },
            { value: "FP+MP_PL", text: 'Facultative pond followed by maturation pond ' },
            { value: "FP_P/L+FWS_CW", text: 'Facultative pond followed by free water surface constructed wetland' },
          ];

        default:
          return [{ value: "", text: 'Select type first' }];
      }
    }
  }
}
</script>
<style>
  .titleColClass{
    max-width: 300px;
  }
  .typeColClass{
    max-width: 100px;
  }
</style>

<style scoped>



  .buttonStyle{
    border-color: #00ACE5 !important;
    color: #00ACE5 !important;

    padding: 10px 30px;

    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 126.5%;
    /* or 20px */

    text-align: center;
    text-transform: uppercase;
  }

  .buttonStyle:hover{
    border-color: #00ACE5 !important;
    background-color: #00ACE5 !important;
    color: white !important;
  }

  .thirdPart{
    color: #5E686D;
    background-image: url("/images/nbslist_lead_image.jpg");
    background-size: cover;
    padding-left: 80px;
    padding-right: 80px;
  }
  .thirdPart h2{
    margin-top: 95px;
    margin-bottom: 35px;
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 43px;
    text-align: center;
  }
  .thirdPart .third-text{
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 26px;
  }

  .thirdPart .line{
    width: 307px;
    border: 1px solid #5E686D;
    margin-left: auto;
    margin-bottom: 82px;
    margin-right: auto;
  }

  .b-icon.bi.collapsed {
    transform: rotate(180deg);
  }
</style>
